<template>
  <div
    class="overviewContent"
    v-if="show"
  >
    <div class="font-medium billing-row-label">
      <span>{{ label }}</span>
      <!-- VP-16821/VP-17387: optional info icon + tooltip (e.g. GZ NY Processing Fee copy). -->
      <el-tooltip
        v-if="tooltip"
        :show-arrow="false"
        :trigger="mobile_version ? 'click' : 'hover'"
        :hide-after="100"
        placement="top"
        popper-class="payment-method-tooltip-popper"
        ref="tooltipRef"
      >
        <img src="@/assets/payment/black_info_icon.svg" class="billing-row-info-icon"/>
        <template #content>
          <div class="tooltip-content">{{ tooltip }}</div>
          <img v-if="mobile_version" class="tooltip-cross" src="@/assets/payment/white_cross_icon.svg" @click="closeTooltip"/>
        </template>
      </el-tooltip>
    </div>
    <div class="font-normal">
      {{ formattedValue }}
    </div>
  </div>
</template>

<script>
import { computed, ref } from 'vue';
import { useWindowSize } from '@vueuse/core';

export default {
  name: 'BillingRow',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    formatPrice: {
      type: Function,
      required: true,
    },
    condition: {
      type: Boolean,
      default: true,
    },
    // VP-16821: when set, an info icon showing this tooltip copy is rendered next to the label.
    tooltip: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { width } = useWindowSize();
    const mobile_version = computed(() => width.value < 768);
    const tooltipRef = ref(null);

    const show = computed(() => {
      if (!props.condition) {
        return false;
      }
      if (props.value === null || props.value === undefined) {
        return false;
      }
      const numericValue = Number(props.value);
      if (isNaN(numericValue)) {
        return true; // Show if not a number (e.g. text)
      }
      return numericValue !== 0;
    });

    const formattedValue = computed(() => {
      if (props.value === null || props.value === undefined) {
        return '- - -';
      }
      return props.formatPrice(props.value);
    });

    const closeTooltip = (event) => {
      tooltipRef.value?.hide();
      event?.stopPropagation();
    };

    return {
      show,
      formattedValue,
      mobile_version,
      tooltipRef,
      closeTooltip,
    };
  },
};
</script>

<style scoped>
.billing-row-label {
  display: flex;
  align-items: center;
  column-gap: 6px;
}
.billing-row-info-icon {
  width: 16px;
  height: 16px;
  cursor: pointer;
  /* black icon recolored to white to match the overview's white text on its dark background */
  filter: brightness(0) invert(1);
}
.tooltip-content {
  color: #F8FEFF;
  padding: 10px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
}
.tooltip-cross {
  padding: 8px;
  cursor: pointer;
}
</style>
